import AccountSummaryPage from "components/pages/AccountSummaryPage";

export default function CaptureStopPaymentAccountSummary(props) {
    return <AccountSummaryPage />
}